import { Children } from "react";
import styles from "./intrests.module.css";
function Card1({children}) {
  return (
    <div className={styles.card}>
        {children}
    </div>
  );
}

export default Card1;
